// The flag stays after the route landed so pulling the links is one edit, not a search.
export const HUB_STORIES_PATH = '/explore/stories';
export const HUB_STORIES_ROUTE_EXISTS = true;
export const HUB_LESSONS_PATH = '/explore/lessons';

export { LIBRARY_PATH as HUB_LIBRARY_PATH } from '@/pages/ResourceCenter/resourceCenter';
